var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-select"},[_c('select',_vm._g({staticClass:"select",domProps:{"value":_vm.value}},_setup.listeners),[_vm._t("default")],2),_c('div',{staticClass:"arrow"},[_c('BaseIcon',{staticClass:"arrow-icon",attrs:{"name":"expand_more"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }